import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/locationgcc/hire-dubai/ready_project.webp";

function Readygoals() {
  return (
    <div
      className="ready_goals p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <h2>Ready to Turn Your Project Goals into Reality?</h2>
            <p>
              Let's discuss your project and transform your ideas into a
              next-level digital product. Get a free discovery call today!
            </p>
            <div className="ready_goals_btn">
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Schedule Your Free Consultation!
              </Link>
            </div>
            <p>Or, use the form below to tell us about your needs</p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Readygoals;
